import React from 'react';
import LinkMessage from './LinkMessage';
import { MessageWrapper, addLineBreaks } from './Message';

export const urlsFromText = text => {
  // eslint-disable-next-line no-useless-escape
  const urlPattern = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:;$%_\+.,~#?!*'&\/=]*)/gi;
  return text.match(urlPattern);
};

const LinkContainingMessage = props => {
  const isWhitespaceOnly = string => /^\s*$/.test(string);

  const separateTextUrlTags = () => {
    const { text, isStart, isEnd, urls } = props;

    const output = [];
    urls.forEach((url, index) => {
      const startIndex = index === 0 ? 0 : text.indexOf(urls[index - 1]) + urls[index - 1].length;
      const lastIndex = text.indexOf(url);
      if (startIndex <= lastIndex && !isWhitespaceOnly(text.slice(startIndex, lastIndex))) {
        output.push(
          <MessageWrapper
            isStart={isStart}
            isEnd={isEnd}
            data-test-type="botMessage"
            type="message"
            key={`${url}${index}0`}
          >
            {addLineBreaks(text.slice(startIndex, lastIndex))}
          </MessageWrapper>
        );
      }

      output.push(
        <LinkMessage isStart={isStart} isEnd={isEnd} key={`${url}${index}1`} urlValue={url} />
      );
    });

    const lastUrlIndex = text.indexOf(urls[urls.length - 1]) + urls[urls.length - 1].length;
    if (lastUrlIndex <= text.length && !isWhitespaceOnly(text.slice(lastUrlIndex))) {
      output.push(
        <MessageWrapper
          isStart={isStart}
          isEnd={isEnd}
          data-test-type="botMessage"
          type="message"
          key={`${urls[urls.length - 1]}${urls.length - 1}2`}
        >
          {addLineBreaks(text.slice(lastUrlIndex))}
        </MessageWrapper>
      );
    }
    return output;
  };

  const output = separateTextUrlTags();
  return <div>{output}</div>;
};

export default LinkContainingMessage;



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/LinkContainingMessage.js